import { connect } from 'react-redux';

import { getBreadcrumbs } from 'redux/modules/search-and-browse/selectors/get-breadcrumbs';
import { getPageSubTitle, getPageTitle } from 'redux/modules/search-and-browse/selectors';
import { hasLocationsMasthead } from 'redux/modules/content/selectors';

import BrowseHeader from 'components/BrowseHeader/BrowseHeader';

export default connect(state => ({
  breadcrumbs: getBreadcrumbs(state),
  splitTitle: hasLocationsMasthead(state),
  subTitle: getPageSubTitle(state),
  title: getPageTitle(state),
}))(BrowseHeader);
